// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import BreadcrumbController from "./breadcrumb_controller"
application.register("breadcrumb", BreadcrumbController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)

import WhitepaperModalController from "./whitepaper_modal_controller"
application.register("whitepaper-modal", WhitepaperModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
